import React from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";

import Aux from "../../../../../components/utility/Aux";
import SpreadsheetOptions from "./SpreadsheetOptions";

/**
 * SpreadsheetControls: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Controls which are displayed beneath the spreadsheet
 * view to edit the spreadsheet's properties
 *
 * @param {*} props
 */
const SpreadsheetControls = props => (
  <Aux className="ed-block-controls">
    {/**
     * Control to add another row to the spreadsheet
     */}
    <Button
      basic
      content={<FormattedMessage id="manuscript.blocks.calc.controls.addRow" />}
      icon="table"
      onClick={() => {
        const columns = [];
        for (let i = 0; i < SpreadsheetOptions.COLUMNS; i += 1) {
          columns.push({ value: "" });
        }
        const grid = [...props.block.grid.map(row => [...row]), columns];
        const block = Object.assign({}, props.block);

        block.grid = grid;
        props.onChange(block);
      }}
    />
    {/**
     * Control to remove the last row
     */}
    {props.block.grid.length > 0 ? (
      <Button
        basic
        content={
          <FormattedMessage id="manuscript.blocks.calc.controls.removeLastRow" />
        }
        icon="delete"
        onClick={() => {
          const grid = [...props.block.grid.map(row => [...row])];
          const block = Object.assign({}, props.block);

          grid.splice(grid.length - 1, 1);
          block.grid = grid;

          props.onChange(block);
        }}
      />
    ) : null}
  </Aux>
);

SpreadsheetControls.propTypes = {
  /**
   * block: {grid: [{}]}
   * Stored grid of the spreadsheet data
   */
  block: PropTypes.shape({
    grid: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({})))
  }).isRequired,

  /**
   * onChange: updatedBlock => ()
   * Fired when a change within the spreadsheet has occurred
   * and passes on updated block data
   */
  onChange: PropTypes.func.isRequired
};

export default SpreadsheetControls;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/spreadsheet/SpreadsheetControls.js